/**
Copyright (C) 2019-2022, Infraclear Inc. All Rights Reserved.
*/

import React from "react";
import "./dashboard.scss";

export const DashboardPage: React.FC<any> = () => {
  return (
    <div className="containerWrapper">
      <span>Dashboard</span>
    </div>
  );
};
